import React, { useEffect, useState } from "react";

const CountdownTimer = ({ targetHours = 36 }) => {
  const [time, setTime] = useState({ d: 1, h: 12, m: 0, s: 0 });

  useEffect(() => {
    const target = Date.now() + targetHours * 60 * 60 * 1000;
    const t = setInterval(() => {
      const diff = target - Date.now();
      if (diff <= 0) { clearInterval(t); return; }
      setTime({
        d: Math.floor(diff / 86400000),
        h: Math.floor((diff % 86400000) / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    }, 1000);
    return () => clearInterval(t);
  }, [targetHours]);

  const Cell = ({ value, label }) => (
    <div className="flex flex-col items-center bg-white rounded-md border border-zinc-200 px-4 py-3 min-w-[64px]">
      <span className="text-2xl font-bold text-zinc-900">{String(value).padStart(2, "0")}</span>
      <span className="text-[10px] uppercase tracking-wider text-zinc-500 mt-1">{label}</span>
    </div>
  );

  return (
    <div className="flex items-center gap-2">
      <Cell value={time.d} label="Days" />
      <span className="text-2xl text-zinc-400">:</span>
      <Cell value={time.h} label="Hours" />
      <span className="text-2xl text-zinc-400">:</span>
      <Cell value={time.m} label="Mins" />
      <span className="text-2xl text-zinc-400">:</span>
      <Cell value={time.s} label="Secs" />
    </div>
  );
};

export default CountdownTimer;
